import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { ISuggestion } from './../model/types'
import { Checkbox } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewSuggestions',
  emits: ['selectSuggestion'],
  setup(__props, { emit }) {



const suggestions = ref<ISuggestion[]>([
  { id: 1, label: 'Обслуживание', active: false },
  { id: 2, label: 'Чистота', active: false },
  { id: 3, label: 'Качество блюд', active: false },
  { id: 4, label: 'Атмосфера', active: false }
])

const selectSuggestion = (id: number) => {
  for (const i of suggestions.value) {
    if (i.id === id) {
      i.active = !i.active
      break
    }
  }

  const tags = suggestions.value.filter(i => i.active)

  emit('selectSuggestion', { type: 'suggestions', tags })
}

return { __sfc: true,emit, suggestions, selectSuggestion, Checkbox }
}

})